import { useEffect, useState } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import { getAutoProvisioningTapTrait } from '../services/FetchSiteUserTraits.tsx';
import { fireErrorAnalytics } from '../common/AutoProvisioningModalAnalytics.tsx';

import { useBillingDetails } from './useBillingDetails.tsx';

export const useShouldCheckEligibilityForSpotlight = () => {
	const { cloudId, edition } = useSessionData();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { hasPaymentDetails } = useBillingDetails({ cloudId });

	const [isEligible, setIsEligible] = useState(false);

	useEffect(() => {
		const fetchEligibility = async () => {
			try {
				const trait = await getAutoProvisioningTapTrait(cloudId);
				const isConfluenceEditionPaid =
					edition === ConfluenceEdition.STANDARD || edition === ConfluenceEdition.PREMIUM;
				const isEligible = isConfluenceEditionPaid && hasPaymentDetails && !!trait;
				setIsEligible(isEligible);
			} catch (error) {
				fireErrorAnalytics(createAnalyticsEvent, 'Error fetching eligibility checks', error);
			}
		};
		void fetchEligibility();
	}, [hasPaymentDetails, edition, cloudId, createAnalyticsEvent]);
	return isEligible;
};
